// LEGACY
import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

import classes from './separator.module.css';

type TVariant = {
  variant?: 'horizontal' | 'vertical';
};

const OrSeparator: FunctionComponent<TVariant> = ({ variant }) => {
  const { t } = useTranslation();

  return (
    <div
      className={cx(
        classes.separator,
        { [classes.separatorVertical]: variant === 'vertical' },
        'flex',
        { 'lg:flex-col': variant === 'vertical' },
        'justify-center',
        'items-center',
        'text-xs',
        'lg:text-sm',
        'leading-3',
        'text-neutral-50',
        'uppercase',
        ''
      )}
    >
      {t('common:or')}
    </div>
  );
};

export default OrSeparator;
